import { tokenPocket, tokenPocketDark } from "../../../utils";

export default {
  product: {
    title: 'Produit',
    label_1: 'KeyPal',
    label_2: 'Secret Box',
    label_3: 'Étui en cuir',
    label_4: 'Tous les accessoires',
  },
  upgrade: {
    label_1: 'Mise à niveau',
  },
  // Descriptions sous les titres "learn"
  learn: {
    label_1: 'Sécurité',
  },
  others: {
    label_1: 'À propos',
    label_2: 'Politique de confidentialité',
    label_3: 'Conditions d’utilisation',
  },
  support: {
    title: 'Support',
    label_1: 'Centre d’aide',
    label_2: 'FAQ d’achat',
    label_3: 'Communauté',
  },
  cryptoAssets: {
    title: 'Actifs cryptographiques',
    label_1: 'Portefeuille Bitcoin',
    label_2: 'Portefeuille Ethereum',
    label_3: 'Portefeuille Solana',
    label_4: 'Portefeuille Tron',
    label_5: 'Portefeuille de stablecoins',
  }, 
  getStarted: {
    title: 'Commencer',
    label_1: 'Comment sécuriser votre portefeuille ?',
    label_2: 'Comment utiliser le KeyPal 2 ?',
    label_3: 'Comment utiliser le KeyPal Card ?',
    label_4: 'Comment utiliser le KeyPal Plus ?',
    label_5: 'Comment utiliser le Secret Box ?',
  }, 
  download: {
    title: 'Télécharger',
    label_1: 'Portefeuille mobile',
    label_2: 'Portefeuille extension',
    label_3: 'Mettre à niveau',
  }, 
  legal: {
    title: 'Aviso legal',
    label_1: 'Política de privacidad',
    label_2: 'Términos de uso',
  }, 

  designed: `Diseñado por ${tokenPocket} ❤️`,
  designedDark: `Diseñado por ${tokenPocketDark} ❤️`,
}
